export const faConstellation = {
  prefix: 'fas',
  iconName: 'constellation',
  icon: [
    190,
    190,
    [],
    null,
    `M188.4,126.5c-0.9-5.2-3.7-9.8-7.8-12.6c-4.1-3-9.2-4.2-14.3-3.3c-4,0.7-7.4,2.7-10.1,5.5l-44.9-31
		c0.9-4.1,0.5-8.4-1.2-12.2c-1.9-4.7-5.8-8.5-10.5-10.4c-3.6-1.4-7.4-1.7-11-0.8l-3.6-10.5c2.5-3.3,4-7.5,4-12
		c0-5.3-1.9-10.2-5.5-13.8c-3.5-3.7-8.5-5.8-13.5-5.8c-4.5,0-8.6,1.6-11.9,4.3l-19.1-5.2c-0.2-4.1-1.7-8.1-4.3-11.3
		C31.4,3.4,26.8,1,21.8,0.6C16.7,0.1,11.5,1.8,7.6,5.2c-3.9,3.4-6.4,8.1-7,13.1C0,23.5,1.5,28.6,4.8,32.7c3.2,3.9,7.8,6.3,12.8,6.7
		c9.1,0.7,17.5-5.2,20.3-13.8l15.3,4.1c-1.5,2.8-2.3,6-2.3,9.3c0,10.8,8.5,19.6,19,19.6c3.4,0,6.6-0.9,9.3-2.5l2.8,8.3
		c-3.3,2.2-5.8,5.5-7.2,9.3c-3.3,8.9,0.1,18.8,7.6,23.6l-7.7,15.8c-4-0.4-8,0.6-11.4,2.7c-4.5,2.7-7.6,7.1-8.8,12.3
		c-2.4,10.5,3.8,21.1,14,23.7c4.9,1.2,10,0.4,14.3-2.2c3-1.9,5.5-4.5,7.1-7.6l23.7,16.7c-1.9,3.1-3.1,6.7-3.1,10.7
		c0,5.3,2.1,10.5,5.9,14.2c3.5,3.5,8.1,5.4,12.9,5.4c0.1,0,0.1,0,0.2,0c10.5,0,19-8.8,19-19.6c0-3.9-1.1-7.5-3-10.7l15.2-11.3
		c3.7,2,7.9,2.7,12.1,2C183.2,147.3,190.2,137.1,188.4,126.5z M140.8,153.4c-3.2-2.4-7.2-3.7-11.2-3.7c-4.2,0-8,1.4-11.2,3.7
		l-26.3-18.5c0.5-4.2-0.4-8.5-2.6-12.3c-1.8-3.2-4.6-5.8-7.8-7.5l7.3-15.1c3.8,0.8,7.7,0.4,11.3-1.3c3.4-1.5,6.2-4,8.2-7.1
		l43.7,30.2c-1.5,3.5-2.1,7.4-1.4,11.5l0,0c0.6,3.6,2.1,6.8,4.4,9.4L140.8,153.4z`
  ]
};